import { render } from "./RequestedCoCrb.vue?vue&type=template&id=64e4b5a0&scoped=true"
import script from "./RequestedCoCrb.vue?vue&type=script&lang=js"
export * from "./RequestedCoCrb.vue?vue&type=script&lang=js"

import "./RequestedCoCrb.vue?vue&type=style&index=0&id=64e4b5a0&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64e4b5a0"]])

export default __exports__